// @flow
import {
  call,
  takeEvery,
  put,
  select,
  race,
} from 'redux-saga/effects';
// import { normalize } from 'normalizr';
import { delay } from 'redux-saga';
import i18n from 'i18n-js';

import { normalize } from 'normalizr';
import { throwTimeout } from '../lib/http';
import { REQUEST_TIMEOUT } from '../settings';
// import { fibonacciBackoff } from '../lib/retry';
import { PARENT_FETCH_STARTED, UPDATE_PARENT_STARTED } from '../types/parents';
import * as selectors from '../reducers';
import * as actions from '../actions/parents';
import * as studentActions from '../actions/students';
import * as temporalBannersActions from '../actions/temporalBanners';
import * as messages from '../utils/errorDefaults';
import { arrayOfStudents } from '../api/schemas/students';
import HTTP_STATUS from '../lib/HTTPStatus';

import { Parents } from '../api';

function* fecthParent(action) {
  const { payload } = action;
  // const { page } = payload;
  const token = yield select(selectors.getToken);

  try {
    const { parentResponse, timeout } = yield race({
      parentResponse: call(
        [Parents, 'detail'],
        { token, id: payload },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchParent saga');
    }

    yield put(actions.fetchParentSucceed(parentResponse));
  } catch (error) {
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(actions.fetchParentFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* updateParent(action) {
  const token = yield select(selectors.getToken);
  const { id } = action.payload;
  let newParent = {
    ...action.payload
  };

  try {
    if (action.payload.phone) {
      newParent["phone"] = `+502${action.payload.phone}`;
    }

    // Update route
    const { parentResponse, timeout } = yield race({
      parentResponse: call(
        [Parents, 'update'],
        {
          token,
          id,
          data: {
            user: { ...newParent },
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('updateParent saga');
    }
    yield put(temporalBannersActions.shout(messages.DEFAULT_UPDATE(i18n.t('common.user', { count: 1 })), 3000, 1, {}));
    yield put(actions.updateParentSuccess({
      ...parentResponse,
    }));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    if (data.phone) {
      yield put(temporalBannersActions.shout(i18n.t('temporalBanners.phoneDuplicated'), 4000, -1, {}));
    } else {
      yield put(temporalBannersActions.shout(i18n.t('temporalBanners.defaultError'), 4000, -1, {}));
    }

    // yield put(userActions.updateUserSucceed(oldUser));
    yield put(actions.updateParentFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al update de user' : message,
      data: isPlain ? 'Error en el servidor' : phone,
      retryAction: action,
    }));
  }
}

function* fecthParentStudents(action) {
  const { payload } = action;
  // const { page } = payload;
  const profile = yield select(selectors.getProfileOfType, 'admin');
  const token = yield select(selectors.getToken);

  try {
    const { studentsResponse, timeout } = yield race({
      studentsResponse: call(
        [Parents.custom, 'students'],
        {
          token,
          id: payload,
          filters: {
            school: profile.school,
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fecthParentStudents saga');
    }

    const {
      entities: { students },
      result = [],
    } = normalize(studentsResponse, arrayOfStudents);

    yield put(studentActions.fetchStudentsSucceed(
      students,
      result,
    ));
  } catch (error) {
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(actions.fetchParentFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}


export function* watchParentFetch(): Iterator<any> {
  yield takeEvery(
    PARENT_FETCH_STARTED,
    fecthParent,
  );
}

export function* watchUpdateParent(): Iterator<any> {
  yield takeEvery(
    UPDATE_PARENT_STARTED,
    updateParent,
  );
}

export function* watchParentStudentsFetch(): Iterator<any> {
  yield takeEvery(
    PARENT_FETCH_STARTED,
    fecthParentStudents,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/parents.js